import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { client } from '../../api/client'

const languagesAdapter = createEntityAdapter({
    selectId: x => x.Id
})

const initialState = languagesAdapter.getInitialState({
    status: 'idle',
    error: null,
})

export const fetchLanguages = createAsyncThunk('languages/Get', async () => {
    const response = await client.get('/Languages')
    return response.data
})

const languagesSlice = createSlice({
    name: 'languages',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchLanguages.pending]: (state, action) => {
            state.status = 'loading'
            state = undefined
        },
        [fetchLanguages.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            languagesAdapter.addMany(state, action.payload)
        },
        [fetchLanguages.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }
    },
})

export default languagesSlice.reducer

export const {
    selectAll: selectAllLanguages,
    selectById: selectLanguagesById,
} = languagesAdapter.getSelectors((state) => state.languages)
